/// not in use currently
import $ from 'jquery';
import {BllinkLogger} from '../../common/utils/bllink_loggers';
import {GAEvent} from "../../common/google_analytics/google_analytics";
import { constants } from "../../common/constants/constants";
var btnChargeEnabled = true;
var prefixErrCls = "errcls-";

let gae = constants.GoogleAnalytics.Events
let gal = constants.GoogleAnalytics.Labels

export default class creditCardLogic{

    static initTranzila(afterSuccessPaymentCallback, thisObj, options){
        /*
            this whole script comes from
            https://vucra.com/online05/oneline05.html
            didn't have time to refactor or take a look
         */
        console.log('after load ');
        var validCCN = false, validCCV = false, validExp = false, validCHID = true;
        var emptyCCN = true, emptyCCV = true, emptyExp = true;

        const credit_card_id = 'credit-card';
        const CVV = 'Cvv';
        let creditCardFound = $(`#${credit_card_id}`).length > 0
        let CvvFound = $(`#${CVV}`).length > 0
        let hasElements = (creditCardFound && CvvFound)
        if (hasElements) {
            this.validateItemsLength(credit_card_id, CVV);
            var fields = window.TzlaHostedFields.create({
                sandbox: false,
                styles: {
                    'input': {
                        'direction': 'ltr',
                        'text-align': 'right',
                        // to avoid Auto Zoom in Input 'Text' tag - Safari on iPhone  when the user want to enter her cc details
                        'font-size': '16px'
                    },
                    'input::placeholder': {
                        'direction': 'ltr',
                        'text-alight': 'right'
                    },
                    '.hosted-fields-invalid:not(:focus)': {
                        'color': 'red'
                    }
                },

                fields: {
                    credit_card_number: {
                        selector: `#${credit_card_id}`,
                        placeholder: 'Credit Card Number',
                        tabindex: 1,
                    },
                    cvv: {
                        selector: `#${CVV}`,
                        placeholder: 'CVV',
                        tabindex: 4
                    },
                    // expiry: {
                    //   // selector: '#expiry',
                    //   selector: '#month',
                    //   placeholder: 'MM/YYYY',
                    //   version: '1',
                    //   tabindex: 3
                    // },
                    // year: {
                    //   // selector: '#expiry',
                    //   selector: '#month',
                    //   placeholder: 'MM/YYYY',
                    //   version: '1',
                    //   tabindex: 3
                    // }
                }
            });

            fields.onEvent('ready', function (event) {
                console.log("ready01---");
                setFocusOnCCnumber();
                $( ".CardField-button" ).prop( "disabled", false );
            });

            fields.onEvent('focus', function (event) {
                console.log("focus01--- "  + event.field);
                var focusedF = $("#" + event.field);
                focusedF.addClass("focusedBorder");
            });

            fields.onEvent('validityChange', function (event) {
                console.log("ready01---validityChange-");
                validExp = true // we don't input the expiry to tranzila
                validCHID = true // we don't use that
                switch (event.field)
                {
                    case "credit_card_number":
                        validCCN = event.isValid;
                        break;
                    case "cvv":
                        validCCV = event.isValid;
                        break;
                    // case "expiry":
                    //     // we dont
                    //     validExp = true //event.isValid;
                    //     break;
                    default:
                        console.error('Default case not defined');
                        break;
                }

                if (validCCN && validCCV && validExp && validCHID) {
                    console.log(`all is valid`);
                    $('.Card-Errors').addClass("Display-None");
                    $( ".CardField-button" ).prop( "disabled", false );
                }

                console.log(`validCCN ${validCCN} validCCV ${validCCV} validExp ${validExp}`)
            });

            fields.onEvent('empty', function (event) {
                console.log("ready01---empty-");

                switch (event.field)
                {
                    case "credit_card_number":
                        emptyCCN = true;
                        break;
                    case "cvv":
                        emptyCCV = true;
                        break;
                    case "expiry":
                        emptyExp = true;
                        break;
                    default:
                        console.error('Default case not defined');
                        break;
                }
            });

            fields.onEvent('notEmpty', function (event) {
                console.log("ready01---notEmpty-");

                switch (event.field)
                {
                    case "credit_card_number":
                        emptyCCN = false;
                        break;
                    case "cvv":
                        emptyCCV = false;
                        break;
                    case "expiry":
                        emptyExp = false;
                        break;
                    default:
                        console.error('Default case not defined');
                        break;
                }
            });

            fields.onEvent('blur', function (event) {
                console.log("ready03---blur- " + event.field);
                var unfocusedF = $("#" + event.field);
                unfocusedF.removeClass("focusedBorder");

                switch (event.field)
                {
                    case "credit_card_number":
                        if (!validCCN && !emptyCCN) {
                            addErr(event.field, "מספר כרטיס אשראי לא תקין. אם המספר שהוקלד נכון, אנא נסה/י שוב ע״י ריענון העמוד ");
                            GAEvent('creditCardErrors', 'errorInCardNumber', 1, 'errorInCardNumber');
                        }else
                            remErr(event.field);
                        break;
                    case "cvv":
                        if (!validCCV && !emptyCCV) {
                            addErr(event.field, "CVV לא תקין אנא בדוק שוב");
                            GAEvent('creditCardErrors', 'CvvError', 1, 'CvvError');
                        }
                        else
                            remErr(event.field);
                        break;
                    case "expiry":
                        if (!validExp && !emptyExp) {
                            addErr(event.field, "תאריך תום תוקף כרטיס לא תקין");
                            GAEvent('creditCardErrors', 'ExpiryError', 1, 'ExpiryError');
                        }
                        else
                            remErr(event.field);
                        break;
                    default:
                        console.error('Default case not defined');
                        break;
                }
            });

            fields.onEvent('inputSubmitRequest', function (event) {
                console.log("ready04---keypress- " + event.field);
            });


            fields.onEvent('cardTypeChange', function (event) {
                /*
                    https://www.marketwatch.com/story/how-to-decode-your-credit-card-numbers-2017-08-25

                    First digit: 2; Credit card issuer: Mastercard (2017)
                    First digit: 3; Credit card issuer: American Express AXP, -2.01%
                    First digit: 4; Credit card issuer: Visa
                    First digit: 5; Credit card issuer: Mastercard
                    First digit: 6; Credit card issuer: Discover DFS, -0.94%

                    options are mc (mastercard), visa, ae, unknown

                 */

                BllinkLogger.info("ready01---cardTypeChange- " + event.cardType);
                thisObj.cardTypeChanged(event.cardType);
            });
        }
        else {
            throw new Error(`elements required for credit card not found creditCardFound ${creditCardFound} CvvFound ${CvvFound}`)
        }


        function setFocusOnCCnumber() {
            var iframeCC = $("#tranzi\\.credit_card_number")[0];
            iframeCC.contentWindow.focus();
        }

        $(function () {

            $('#payment_form').on('submit', function(e){
                e.preventDefault();
                if (btnChargeEnabled) {
                    btnChargeEnabled = false;

                    $(".CardField-button").prop("disabled", true ).addClass("disabled-CardField-button");
                    chargeCCData();
                }
            });
        });

        function chargeCCData(){
            const amount = $('#total-amount-for-card').val();
            const cartId = $('#cartID-input').val();
            const paymentsToken = $('#paymentsToken-input').val(); // currently used only for failed payments
            const terminalName = options.paymentTerminal || 'ptop';
            BllinkLogger.info(`paymentsToken is ${paymentsToken} terminalName is ${terminalName}`);
            // const transActionMode = true //always direct charge  $('#transActionMode').val();
            if (!amount){
                alert('שגיאה. אנא נסה שנית.')
                thisObj.endLoader()
                throw new Error(`failed to charge user. missing amount`)
            }
            let payload = {

                expiry_month: $('.js-month').children("option:selected").val(),
                expiry_year: $('.js-year').children("option:selected").val(),
                terminal_name: terminalName,
                tokenize: true, // to get the token back in the callback
                // `cartId` is a parameter defined at the tranzila (our payment gateway) system.
                cartId: cartId,
                amount: parseFloat(amount),
                ...(options.tran_mode && {tran_mode: options.tran_mode, tranmode: options.tran_mode, transaction_mode: options.tran_mode}),
            }

            if (paymentsToken){
                // `paymentsToken` is a parameter defined at the tranzila (our payment gateway) system.
                // used for failed payments feature only currently
                payload.paymentsToken = paymentsToken;
            }
            /// https://app.asana.com/0/1201421792207582/1201550079654913
            if (options.tran_mode === 'V') {
                // to avoid catching the user's credit limit
                // the point is to get the token for a charge at
                // a later date and not to charge now
                // part use case is users who DONT have the credit limit and will have in a later date
                // https://app.asana.com/0/1201421792207582/1201550079654913
                BllinkLogger.info(`small amount for J5 transaction. will not get token`);
                payload.amount = 1;
            }
            // todo add currency 2 (usd) if sent from
            if (thisObj.props.currency && typeof thisObj.props.currency === 'string') {
                console.log(`Setting currency to: ${thisObj.props.currency} for cartId: ${payload.cartId}`);
                payload.currency_code = thisObj.props.currency.toUpperCase();
            }

            console.log('charging with ', payload);
            thisObj.startLoader();
            // todo graph charge time to help alert when tranzila is slow
            fields.charge(
                payload,
                function(err, response) {
                    if(err) {
                        btnChargeEnabled = true;
                        thisObj.endLoader()
                        BllinkLogger.error(`error in charging callback `, err);

                        handleErrors(err);

                        return;
                    }

                    const hasErrors = (response.errors && response.errors.length > 0)
                    const errorResponse = (response.transaction_response && !response.transaction_response.success);
                    BllinkLogger.info(`hasErrors ${hasErrors} and errorResponse ${errorResponse}`)
                    if (hasErrors) {
                        BllinkLogger.error(`error in charging hasErrors`, response);
                        BllinkLogger.error(`errors are `, response.errors);
                        thisObj.endLoader()
                        alert('שגיאת תשלום, אנא נסה שוב')
                        GAEvent(gae.creditCard, 'ErrorsInCharge', amount, 'ErrorsInCharge');
                        console.log(`Payment charge errors! response from tranzila `, response);

                    }else if (errorResponse){
                        thisObj.endLoader()
                        BllinkLogger.error(`error in charging Text`, response);
                        const errorText = response.transaction_response.error;
                        GAEvent(gae.creditCard, 'ErrorsInChargeText', amount, errorText);
                        thisObj.showErrorPopUp(errorText);

                    }else {

                        $('.Card-Errors').addClass("Display-None");
                        const buildingID = (thisObj.state && thisObj.state.createCartResponse) ?  thisObj.state.createCartResponse.buildingID : null;
                        BllinkLogger.info(`Payment charge success! response from tranzila for  building ${buildingID} `, response);
                        let eventLabel = options.isFailedPaymentForm ? gal.creditCard.bllinkUIUpdateCard : gal.creditCard.bllinkUI;
                        GAEvent(gae.creditCard, 'SuccessCharge', amount, eventLabel);
                        if (buildingID) {
                            // to count active buildings
                            GAEvent(gae.creditCard, 'BuildingSuccessCharge', 1, thisObj.state.createCartResponse.buildingID);
                        }

                        afterSuccessPaymentCallback(cartId, thisObj, 1)
                    }
                }
            );
        }

        function remErr(fld) {
            $( "." + prefixErrCls + fld).remove();
        }

        function addErr(fld, err) {
            remErr(fld);
            $('.Card-Errors').prepend('<p class="' + prefixErrCls + fld + '">' + err + '</p>');
        }

        function handleErrors(err){
            $('.Card-Errors').empty();
            console.error(`error is `, err);
            let errAll;
            if(err.messages) {
                err.messages.forEach(function(errMsg){
                    errAll += " - " + errMsg.message;
                    //$('.Card-Errors').append('<p>' + errMsg.message + '</p>');
                    addErr(errMsg.param, errMsg.message);
                });
            } else {
                errAll = "server error for our payment provider.";
                //$('.Card-Errors').append('<p>' + errAll + '</p>');
                addErr("", errAll);
                // to report to sentry
                throw err
            }

            GAEvent('creditCardErrors', 'ChargeError', 1, errAll);

            $('.Card-Errors').removeClass("Display-None");
        }

    }


    static validateItemsLength(creditCardId, cvvID){
        let creditCardFound = $(`#${creditCardId}`).length
        let CvvFound = $(`#${cvvID}`).length

        if (creditCardFound > 1 || CvvFound> 1){
            throw new Error(`found too many fields to init creditCardFound ${creditCardFound}  CvvFound ${CvvFound}`)
        }

    }
}
